export default 'Mandataire CEE pour artisans RGE : 0 € d\'avance, dossier déposé et suivi, paiement sous 30 à 60 jours. Mandat signé en 5 minutes. Décret 25 mars 2022 respecté.';
